/* @generated from adl module krodok.snappy.db */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_db from './../../common/db';
import * as common_strings from './../../common/strings';
import * as sys_types from './../../sys/types';

/**
 * Details for a user
 */
export interface AppUser {
  fullname: common_strings.StringNE;
  email: common_strings.StringNE;
  isAdmin: boolean;
  hashedPassword: common_strings.StringNE;
}

export function makeAppUser(
  input: {
    fullname: common_strings.StringNE,
    email: common_strings.StringNE,
    isAdmin: boolean,
    hashedPassword?: common_strings.StringNE,
  }
): AppUser {
  return {
    fullname: input.fullname,
    email: input.email,
    isAdmin: input.isAdmin,
    hashedPassword: input.hashedPassword === undefined ? "" : input.hashedPassword,
  };
}

const AppUser_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["email"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details for a user\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"fullname","default":{"kind":"nothing"},"name":"fullname","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"isAdmin","default":{"kind":"nothing"},"name":"isAdmin","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"hashedPassword","default":{"kind":"just","value":""},"name":"hashedPassword","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"AppUser","version":{"kind":"nothing"}}};

export const snAppUser: ADL.ScopedName = {moduleName:"krodok.snappy.db", name:"AppUser"};

export function texprAppUser(): ADL.ATypeExpr<AppUser> {
  return {value : {typeRef : {kind: "reference", value : snAppUser}, parameters : []}};
}

export type AppUserId = common_db.DbKey<AppUser>;

const AppUserId_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.db","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"AppUser"}},"parameters":[]}]}}},"name":"AppUserId","version":{"kind":"nothing"}}};

export const snAppUserId: ADL.ScopedName = {moduleName:"krodok.snappy.db", name:"AppUserId"};

export function texprAppUserId(): ADL.ATypeExpr<AppUserId> {
  return {value : {typeRef : {kind: "reference", value : snAppUserId}, parameters : []}};
}

/**
 * messages posted on the noticeboard
 */
export interface Message {
  postedAt: common.Instant;
  postedBy: common_db.DbKey<AppUser>;
  message: common_strings.StringML;
}

export function makeMessage(
  input: {
    postedAt: common.Instant,
    postedBy: common_db.DbKey<AppUser>,
    message: common_strings.StringML,
  }
): Message {
  return {
    postedAt: input.postedAt,
    postedBy: input.postedBy,
    message: input.message,
  };
}

const Message_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["posted_at"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"messages posted on the noticeboard\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"postedAt","default":{"kind":"nothing"},"name":"postedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"postedBy","default":{"kind":"nothing"},"name":"postedBy","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"message","default":{"kind":"nothing"},"name":"message","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringML"}},"parameters":[]}}]}},"name":"Message","version":{"kind":"nothing"}}};

export const snMessage: ADL.ScopedName = {moduleName:"krodok.snappy.db", name:"Message"};

export function texprMessage(): ADL.ATypeExpr<Message> {
  return {value : {typeRef : {kind: "reference", value : snMessage}, parameters : []}};
}

export type MessageId = common_db.DbKey<Message>;

const MessageId_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.db","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"Message"}},"parameters":[]}]}}},"name":"MessageId","version":{"kind":"nothing"}}};

export const snMessageId: ADL.ScopedName = {moduleName:"krodok.snappy.db", name:"MessageId"};

export function texprMessageId(): ADL.ATypeExpr<MessageId> {
  return {value : {typeRef : {kind: "reference", value : snMessageId}, parameters : []}};
}

/**
 * Applications created for registry with the PPSR
 */
export interface Application {
  createdAt: common.Instant;
  contactEmail: string;
  companyType: CompanyType;
  acceptedTOS: boolean;
  payment: Payment;
  documentUrl: string;
  applicationData: LoanSuiteApplication;
}

export function makeApplication(
  input: {
    createdAt: common.Instant,
    contactEmail: string,
    companyType: CompanyType,
    acceptedTOS: boolean,
    payment: Payment,
    documentUrl: string,
    applicationData: LoanSuiteApplication,
  }
): Application {
  return {
    createdAt: input.createdAt,
    contactEmail: input.contactEmail,
    companyType: input.companyType,
    acceptedTOS: input.acceptedTOS,
    payment: input.payment,
    documentUrl: input.documentUrl,
    applicationData: input.applicationData,
  };
}

const Application_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["contactEmail"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Applications created for registry with the PPSR\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"contactEmail","default":{"kind":"nothing"},"name":"contactEmail","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"companyType","default":{"kind":"nothing"},"name":"companyType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"CompanyType"}},"parameters":[]}},{"annotations":[],"serializedName":"acceptedTOS","default":{"kind":"nothing"},"name":"acceptedTOS","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"payment","default":{"kind":"nothing"},"name":"payment","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"Payment"}},"parameters":[]}},{"annotations":[],"serializedName":"documentUrl","default":{"kind":"nothing"},"name":"documentUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"applicationData","default":{"kind":"nothing"},"name":"applicationData","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"LoanSuiteApplication"}},"parameters":[]}}]}},"name":"Application","version":{"kind":"nothing"}}};

export const snApplication: ADL.ScopedName = {moduleName:"krodok.snappy.db", name:"Application"};

export function texprApplication(): ADL.ATypeExpr<Application> {
  return {value : {typeRef : {kind: "reference", value : snApplication}, parameters : []}};
}

export type ApplicationId = common_db.DbKey<Application>;

const ApplicationId_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.db","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"Application"}},"parameters":[]}]}}},"name":"ApplicationId","version":{"kind":"nothing"}}};

export const snApplicationId: ADL.ScopedName = {moduleName:"krodok.snappy.db", name:"ApplicationId"};

export function texprApplicationId(): ADL.ATypeExpr<ApplicationId> {
  return {value : {typeRef : {kind: "reference", value : snApplicationId}, parameters : []}};
}

export enum PaymentStatus {
  unprocessed,
  processed,
}

const PaymentStatus_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"unprocessed","default":{"kind":"nothing"},"name":"unprocessed","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"processed","default":{"kind":"nothing"},"name":"processed","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"PaymentStatus","version":{"kind":"nothing"}}};

export const snPaymentStatus: ADL.ScopedName = {moduleName:"krodok.snappy.db", name:"PaymentStatus"};

export function texprPaymentStatus(): ADL.ATypeExpr<PaymentStatus> {
  return {value : {typeRef : {kind: "reference", value : snPaymentStatus}, parameters : []}};
}

export interface Payment {
  status: PaymentStatus;
  paymentIntentId: string;
}

export function makePayment(
  input: {
    status: PaymentStatus,
    paymentIntentId: string,
  }
): Payment {
  return {
    status: input.status,
    paymentIntentId: input.paymentIntentId,
  };
}

const Payment_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"PaymentStatus"}},"parameters":[]}},{"annotations":[],"serializedName":"paymentIntentId","default":{"kind":"nothing"},"name":"paymentIntentId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"Payment","version":{"kind":"nothing"}}};

export const snPayment: ADL.ScopedName = {moduleName:"krodok.snappy.db", name:"Payment"};

export function texprPayment(): ADL.ATypeExpr<Payment> {
  return {value : {typeRef : {kind: "reference", value : snPayment}, parameters : []}};
}

export interface LoanSuiteApplication {
  companyName: string;
  companyAcn: string;
  companyRegisteredAddress: string;
  companyEmail: string;
  jurisdiction: string;
  lenders: Lender[];
  loanAmount: string;
  loanInterestRate: string;
  directors: Director[];
  meetingDate: common.LocalDate;
  meetingTime: string;
  meetingSuburb: string;
  meetingChairman: string;
  contactEmail: string;
  loanType: sys_types.Maybe<LoanType>;
  initialLoanDate: sys_types.Maybe<common.LocalDate>;
  loanAmountRepaid: sys_types.Maybe<string>;
}

export function makeLoanSuiteApplication(
  input: {
    companyName: string,
    companyAcn: string,
    companyRegisteredAddress: string,
    companyEmail: string,
    jurisdiction: string,
    lenders: Lender[],
    loanAmount: string,
    loanInterestRate: string,
    directors: Director[],
    meetingDate: common.LocalDate,
    meetingTime: string,
    meetingSuburb: string,
    meetingChairman: string,
    contactEmail: string,
    loanType: sys_types.Maybe<LoanType>,
    initialLoanDate: sys_types.Maybe<common.LocalDate>,
    loanAmountRepaid: sys_types.Maybe<string>,
  }
): LoanSuiteApplication {
  return {
    companyName: input.companyName,
    companyAcn: input.companyAcn,
    companyRegisteredAddress: input.companyRegisteredAddress,
    companyEmail: input.companyEmail,
    jurisdiction: input.jurisdiction,
    lenders: input.lenders,
    loanAmount: input.loanAmount,
    loanInterestRate: input.loanInterestRate,
    directors: input.directors,
    meetingDate: input.meetingDate,
    meetingTime: input.meetingTime,
    meetingSuburb: input.meetingSuburb,
    meetingChairman: input.meetingChairman,
    contactEmail: input.contactEmail,
    loanType: input.loanType,
    initialLoanDate: input.initialLoanDate,
    loanAmountRepaid: input.loanAmountRepaid,
  };
}

const LoanSuiteApplication_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"companyName","default":{"kind":"nothing"},"name":"companyName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"companyAcn","default":{"kind":"nothing"},"name":"companyAcn","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"companyRegisteredAddress","default":{"kind":"nothing"},"name":"companyRegisteredAddress","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"companyEmail","default":{"kind":"nothing"},"name":"companyEmail","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"jurisdiction","default":{"kind":"nothing"},"name":"jurisdiction","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"lenders","default":{"kind":"nothing"},"name":"lenders","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"Lender"}},"parameters":[]}]}},{"annotations":[],"serializedName":"loanAmount","default":{"kind":"nothing"},"name":"loanAmount","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"loanInterestRate","default":{"kind":"nothing"},"name":"loanInterestRate","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"directors","default":{"kind":"nothing"},"name":"directors","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"Director"}},"parameters":[]}]}},{"annotations":[],"serializedName":"meetingDate","default":{"kind":"nothing"},"name":"meetingDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"meetingTime","default":{"kind":"nothing"},"name":"meetingTime","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"meetingSuburb","default":{"kind":"nothing"},"name":"meetingSuburb","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"meetingChairman","default":{"kind":"nothing"},"name":"meetingChairman","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"contactEmail","default":{"kind":"nothing"},"name":"contactEmail","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"loanType","default":{"kind":"nothing"},"name":"loanType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Maybe"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"LoanType"}},"parameters":[]}]}},{"annotations":[],"serializedName":"initialLoanDate","default":{"kind":"nothing"},"name":"initialLoanDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Maybe"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"loanAmountRepaid","default":{"kind":"nothing"},"name":"loanAmountRepaid","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Maybe"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"LoanSuiteApplication","version":{"kind":"nothing"}}};

export const snLoanSuiteApplication: ADL.ScopedName = {moduleName:"krodok.snappy.db", name:"LoanSuiteApplication"};

export function texprLoanSuiteApplication(): ADL.ATypeExpr<LoanSuiteApplication> {
  return {value : {typeRef : {kind: "reference", value : snLoanSuiteApplication}, parameters : []}};
}

export interface Lender {
  name: string;
  address: string;
}

export function makeLender(
  input: {
    name: string,
    address: string,
  }
): Lender {
  return {
    name: input.name,
    address: input.address,
  };
}

const Lender_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"address","default":{"kind":"nothing"},"name":"address","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"Lender","version":{"kind":"nothing"}}};

export const snLender: ADL.ScopedName = {moduleName:"krodok.snappy.db", name:"Lender"};

export function texprLender(): ADL.ATypeExpr<Lender> {
  return {value : {typeRef : {kind: "reference", value : snLender}, parameters : []}};
}

export interface Director {
  name: string;
}

export function makeDirector(
  input: {
    name: string,
  }
): Director {
  return {
    name: input.name,
  };
}

const Director_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"Director","version":{"kind":"nothing"}}};

export const snDirector: ADL.ScopedName = {moduleName:"krodok.snappy.db", name:"Director"};

export function texprDirector(): ADL.ATypeExpr<Director> {
  return {value : {typeRef : {kind: "reference", value : snDirector}, parameters : []}};
}

export enum CompanyType {
  new,
  existing,
}

const CompanyType_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"new","default":{"kind":"nothing"},"name":"new","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"existing","default":{"kind":"nothing"},"name":"existing","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"CompanyType","version":{"kind":"nothing"}}};

export const snCompanyType: ADL.ScopedName = {moduleName:"krodok.snappy.db", name:"CompanyType"};

export function texprCompanyType(): ADL.ATypeExpr<CompanyType> {
  return {value : {typeRef : {kind: "reference", value : snCompanyType}, parameters : []}};
}

export enum LoanType {
  new,
  existing,
}

const LoanType_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"new","default":{"kind":"nothing"},"name":"new","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"existing","default":{"kind":"nothing"},"name":"existing","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"LoanType","version":{"kind":"nothing"}}};

export const snLoanType: ADL.ScopedName = {moduleName:"krodok.snappy.db", name:"LoanType"};

export function texprLoanType(): ADL.ATypeExpr<LoanType> {
  return {value : {typeRef : {kind: "reference", value : snLoanType}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "krodok.snappy.db.AppUser" : AppUser_AST,
  "krodok.snappy.db.AppUserId" : AppUserId_AST,
  "krodok.snappy.db.Message" : Message_AST,
  "krodok.snappy.db.MessageId" : MessageId_AST,
  "krodok.snappy.db.Application" : Application_AST,
  "krodok.snappy.db.ApplicationId" : ApplicationId_AST,
  "krodok.snappy.db.PaymentStatus" : PaymentStatus_AST,
  "krodok.snappy.db.Payment" : Payment_AST,
  "krodok.snappy.db.LoanSuiteApplication" : LoanSuiteApplication_AST,
  "krodok.snappy.db.Lender" : Lender_AST,
  "krodok.snappy.db.Director" : Director_AST,
  "krodok.snappy.db.CompanyType" : CompanyType_AST,
  "krodok.snappy.db.LoanType" : LoanType_AST
};
